export var legacyGridBridgeDataClientDIKey = "legacy_grid_bridge_data_client";
//# sourceMappingURL=legacyConstants.js.map